/**
 * Helper de redirection SystemPay (mode V2 redirection).
 * Recoit la payload {action, url, fields} envoyee par le backend
 * et cree un formulaire HTML qui se soumet automatiquement,
 * redirigeant le client vers paiement.systempay.fr/vads-payment/
 */
export function redirectToSystemPay(redirectForm) {
  if (!redirectForm || !redirectForm.url || !redirectForm.fields) {
    throw new Error('redirect_form invalide');
  }
  const form = document.createElement('form');
  form.method = redirectForm.action || 'POST';
  form.action = redirectForm.url;
  form.style.display = 'none';
  Object.entries(redirectForm.fields).forEach(([key, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
}
